export const defaultState = {
  id: null,
  certificateHolder: null,
  certificateLevelDomain: null,
  certificationBody: null,
  issueDate: null,
  type: null,
  validUntil: null,
  certId: '',
  holderAuthorized: null,
  visibility: null,
  otherAssessors: [],
  headAssessor: null,
  signedAssessor: null,
  assessorOptions: [],
  language: null,
  fullHeadAssessor: null,
  fullSignedAssessor: null,
};

const SET_EDIT_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });
export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_EDIT_DATA) {
    const headAssessor =
      action.payload.assessors?.find((assessor) => assessor.assessorType === 'H') || null;
    const signedAssessor =
      action.payload.assessors?.find((assessor) => assessor.assessorType === 'S') || null;
    const otherAssessors =
      action.payload.assessors
        ?.filter((assessor) => assessor.assessorType === 'O')
        ?.map((assessor) => assessor.memberAssociationUserRole?.id)
        ?.filter(Boolean) || [];

    return {
      ...state,
      ...action.payload,
      certificateHolder: action.payload.certificateHolder?.id,
      certificateLevelDomain: action.payload.levelDomain?.id,
      certificationBody: action.payload.certificationBody?.id,
      issueDate: action.payload.issueDate ? new Date(action.payload.issueDate) : undefined,
      validUntil: action.payload.validUntil ? new Date(action.payload.validUntil) : undefined,
      birthDate: action.payload.birthDate ? new Date(action.payload.birthDate) : undefined,
      organization: action.payload.organization?.id,
      memberAssociation: action.payload.memberAssociation?.id,
      headAssessor: headAssessor?.memberAssociationUserRole?.id,
      signedAssessor: signedAssessor?.memberAssociationUserRole?.id,
      otherAssessors: otherAssessors,
      language: action.payload.language?.id,
      fullHeadAssessor: headAssessor,
      fullSignedAssessor: signedAssessor,
    };
  }

  if (action.type === UPDATE_FIELD) {
    if (action.payload.name === 'issueDate') {
      const newValidUnitil = new Date(action.payload.value);
      newValidUnitil.setFullYear(newValidUnitil.getFullYear() + 5);
      newValidUnitil.setDate(newValidUnitil.getDate() - 1);
      return { ...state, [action.payload.name]: action.payload.value, validUntil: newValidUnitil };
    }
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
